import { DynamicStandaloneProse } from '@/components/Prose';
import { propClassName } from '@/styles/Factbox';
import { Component } from '@/types/component';
import { ProseProps } from 'base/components/Prose/Prose';
import { cn } from 'lib/utils/cn';

export type FactboxBodyProps = ProseProps;

export const FactboxBodyComponent: Component<ProseProps> = ({ className, colors, size, variant, ...props }) => {
  const variantClassName = propClassName('body_variant', variant);
  const sizeClassName = propClassName('body_size', size);
  const colorsClassName = propClassName('body_colors', colors);

  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return <DynamicStandaloneProse options={{ className: componentClassName }} {...props} />;
};
